/* eslint-disable flowtype/no-types-missing-file-annotation */
import React from 'react';
import {
    Box, Text, Button, Layer, Heading,
} from 'grommet';
import { useHistory } from 'react-router';
import { injectIntl, useIntl } from 'react-intl';
import GreenButton from 'esm-web-pro/components/layout/GreenButton';

type Props = {
    error: Object,
    resetError: () => void,
    componentStack: string,
}


function ErrorFallbackComponent(props: Props) {
    const { error, resetError, componentStack } = props;
    const history = useHistory();
    const { formatMessage } = useIntl();

    const handleClose = () => {
        resetError();
        // Go back to the previous page otherwise we can enter an error loop
        // where the same error is thrown again and again
        history.goBack();
    };

    return (
        <Layer modal zIndex={1000}>
            <Box pad="small">
                <Box flex={false} direction="row" justify="between" margin={{ bottom: 'small' }}>
                    <Heading level={5} margin="none">{formatMessage({ id: 'error-title' })}</Heading>
                </Box>
                <Text textAlign="center">
                    {formatMessage({ id: 'error-fallback-message' })}
                </Text>
                <Box justify="center" margin={{ top: 'small' }} direction="row" gap="small">
                    <Box key="close" dirextion="row" height="32px">
                        <GreenButton
                            fill
                            label="OK"
                            alignSelf="end"
                            color="status-error"
                            onClick={handleClose}
                        />
                    </Box>
                </Box>
            </Box>
        </Layer>
    );
}

export default injectIntl(ErrorFallbackComponent);
